import {
  EntityTextFilter,
  useEntityList,
} from '@backstage/plugin-catalog-react';
import { useEffect, useMemo, useState } from 'react';
import useDebounce from 'react-use/esm/useDebounce';

const toQueryValue = (value?: string | string[]) =>
  Array.isArray(value) ? value[0] : value;

export const useDocsExplorerState = () => {
  const { queryParameters, updateFilters } = useEntityList();

  const queryParamText = useMemo(
    () => toQueryValue(queryParameters.text) ?? '',
    [queryParameters.text],
  );
  const [searchText, setSearchText] = useState(queryParamText);

  useEffect(() => {
    setSearchText(previous =>
      previous === queryParamText ? previous : queryParamText,
    );
  }, [queryParamText]);

  useDebounce(
    () => {
      const nextSearch = searchText.trim();

      updateFilters({
        text: nextSearch ? new EntityTextFilter(nextSearch) : undefined,
      });
    },
    250,
    [searchText, updateFilters],
  );

  return {
    searchText,
    setSearchText,
  };
};
